import ActiveCall from './ActiveCall'
import { connect } from 'react-redux';

function CallPopUp(props) {
  const { isCallActive, active_call_popup, callInfo } = props

  return (
    <>
      {(isCallActive && callInfo.callStatus === 'call_started') && <ActiveCall active_call_popup={active_call_popup} />}
    </>
  )
}

const mapStateToProps = state => {
  const { voip } = state;

  return {
    isCallActive: voip?.calling_info.isCallActive,
    active_call_popup: voip?.active_call_popup,
    callInfo: voip?.calling_info,
  }
}

export default connect(mapStateToProps)(CallPopUp);